<div [id]="uniqueIdForRoot" class="chart-root">
	@if (data === null) {
		<div class="spinner-border text-primary">
			<span class="sr-only">Loading...</span>
		</div>
	}

	@if (showModal()) {
		<div class="graph-cloak"></div>
	}
	@if (showModal()) {
		<div class="edit-point-modal">
			<chart-modal-edit-form
				(closeEmitted)="closeModal()"
				(deleteEmitted)="deletePoint.emit($event)"
				(saveEmitted)="editPoint.emit($event)"
				[data]="contextForPointEdit"
				[unit]="settings?.unit"
			></chart-modal-edit-form>
		</div>
	}
</div>
